import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.isProduction) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.environment,
    release: environment.release,
    debug: environment.isProduction ? false : true,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['localhost', environment.apiUrl],
        routingInstrumentation: Sentry.routingInstrumentation
      })
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.25
  });

  enableProdMode();
} else {
  console.log('Environment:', environment);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => console.log(`Bootstrap success`))
  .catch((err) => console.error(err));
